import React from "react";
import "./WhyChooseUs.css";
import { FaLightbulb, FaHeadset, FaCheckCircle } from "react-icons/fa";
import { GiReceiveMoney } from "react-icons/gi";

const WhyChooseUs = ({ isDarkMode }) => {
  return (
    <section className={`why-choose-us ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <h2>Why Choose Us?</h2>

      <div className="cards-container">
        {/* Cutting-edge strategies */}
        <article className="card">
          <FaLightbulb className="icon" aria-label="Innovation" />
          <h3>Innovative Solutions</h3>
          <p>Cutting-edge strategies tailored for your business.</p>
        </article>

        {/* Affordable Pricing */}
        <article className="card">
          <GiReceiveMoney className="icon" aria-label="Affordable Pricing" />
          <h3>Cost-Effective</h3>
          <p>Affordable pricing with top-tier quality.</p>
        </article>

        {/* Dedicated Support */}
        <article className="card">
          <FaHeadset className="icon" aria-label="Customer Support" />
          <h3>24/7 Support</h3>
          <p>Dedicated support to ensure your success.</p>
        </article>

        {/* Proven Success */}
        <article className="card">
          <FaCheckCircle className="icon" aria-label="Proven Success" />
          <h3>Proven Results</h3>
          <p>Proven track record with satisfied clients.</p>
        </article>
      </div>

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "AstraSight Technologies",
          "url": "https://astrasighttech.com",
          "description": "Why choose AstraSight Technologies? We provide innovative, cost-effective, and reliable digital solutions with 24/7 support and a proven track record.",
          "serviceType": ["Web Development", "Marketing", "Cybersecurity"],
          "offers": {
            "@type": "Offer",
            "description": "Cutting-edge digital services to elevate your business."
          }
        })}
      </script>
    </section>
  );
};

export default WhyChooseUs;
